import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import type { TradeWay } from 'state/secondaryMarket/secondaryMarket.model';
import type { Collection } from 'state/utils/types';

export type SidePanelStatus =
  | 'NOT_READY'
  | 'READY'
  | 'QUOTING'
  | 'QUOTED'
  | 'QUOTE_FAILED'
  | 'QUOTE_REJECTED'
  | 'TRADING'
  | 'TRADED'
  | 'TRADE_FAILED'
  | 'TRADE_REJECTED';

export type DealSplit = Readonly<{
  custodianId?: string;
  notional?: number;
}>;

export type DealSplitList = ReadonlyArray<DealSplit>;

export type SecondaryMarketQuoteRtForm = Readonly<{
  client?: ISalesCounterpart;
  quantity?: number;
  tradeWay: TradeWay;
  upfrontFee: boolean;
  dealSplits?: DealSplitList;
  quoteId: string | null;
  quoteStatus: 'NONE' | 'PENDING' | 'FAILED' | 'REJECTED' | 'SUCCESS';
  errorMessage?: string;
}> &
  Record<`custodian-${number}`, unknown>;

export type SecondaryMarketQuoteRtFormField = keyof SecondaryMarketQuoteRtForm;

export type SecondaryMarketRtQuoteTabContent = Omit<SecondaryMarketQuoteRtForm, 'quoteStatus' | 'quoteId'>;

export type SecondaryMarketQuoteRtFormMap = Collection<SecondaryMarketQuoteRtForm>;

export const initialQuoteRtFormMap: SecondaryMarketQuoteRtFormMap = {};

export const initialQuoteRtForm: SecondaryMarketQuoteRtForm = {
  upfrontFee: false,
  quoteStatus: 'NONE',
  quoteId: null,
  tradeWay: 'ClientSell',
};
